import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CheckIcon from "@mui/icons-material/Check";
import { CustomText, WrapperContainer, } from "@corporate-trip-planner-fe/ui-styles";
import { useClipboard } from "@corporate-trip-planner-fe/hooks";
import { Button, InputAdornment, TextField } from "@mui/material";
export function CopyContent(_a) {
    var title = _a.title, _b = _a.displayText, displayText = _b === void 0 ? "" : _b, textToCopy = _a.textToCopy;
    var _c = useClipboard(), copied = _c.copied, copyToClipboard = _c.copyToClipboard;
    var handleCopy = function () {
        copyToClipboard(textToCopy ? textToCopy : displayText, "Link copied to clipboard");
    };
    return (_jsxs(WrapperContainer, { "$flexDirection": "column", "$gap": "0.5rem", "$padding": "0", children: [_jsx(CustomText, { "$fontSize": "0.75rem", "$fontWeight": "700", "$color": "#5f6368", children: title }), _jsx(WrapperContainer, { "$responsive": false, "$justifyContent": "space-between", "$cursor": "pointer", "$gap": "1rem", "$padding": "0", children: _jsx(TextField, { fullWidth: true, value: displayText, variant: "outlined", InputProps: {
                        readOnly: true,
                        sx: { borderRadius: "12px", bgcolor: "#f8f9fa" },
                        endAdornment: (_jsx(InputAdornment, { position: "end", children: _jsx(Button, { startIcon: copied ? (_jsx(CheckIcon, {})) : (_jsx(ContentCopyIcon, { fontSize: "small" })), onClick: handleCopy, sx: {
                                    textTransform: "none",
                                    fontWeight: 700,
                                    borderRadius: "8px",
                                }, children: copied ? "Copied" : "Copy" }) })),
                    } }) })] }));
}
